import { numberToString } from "./numberToString.js";
/**
 * Convert number like 5 to plate position 'A5'
 * @param number
 * @param width
 * @returns
 */
export function numberToPosition(number, width) {
    if (width === undefined) {
        throw new Error('need to specify width for numberToPosition');
    }
    number--;
    return (numberToString(Math.floor(number / width) + 1) +
        String((number % width) + 1));
}
//# sourceMappingURL=numberToPosition.js.map